<template>
  <div>

    <div v-if="!prescriptions.length" class="text-sm text-gray-400 py-4">
      No prescriptions recorded for this visit.
    </div>

    <div v-else class="overflow-x-auto">
      <table class="w-full text-sm">
        <thead>
          <tr class="bg-gray-50 text-left">
            <th class="px-3 py-2 text-xs font-semibold text-gray-500 uppercase">Drug</th>
            <th class="px-3 py-2 text-xs font-semibold text-gray-500 uppercase">Dose</th>
            <th class="px-3 py-2 text-xs font-semibold text-gray-500 uppercase">Frequency</th>
            <th class="px-3 py-2 text-xs font-semibold text-gray-500 uppercase">Route</th>
            <th class="px-3 py-2 text-xs font-semibold text-gray-500 uppercase">Duration</th>
            <th class="px-3 py-2 text-xs font-semibold text-gray-500 uppercase">Qty</th>
            <th class="px-3 py-2 text-xs font-semibold text-gray-500 uppercase">Status</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100">
          <tr v-for="(rx, index) in prescriptions" :key="index">
            <td class="px-3 py-3">
              <p class="font-medium text-gray-800">{{ rx.inventory_item?.trade_name || '—' }}</p>
              <p class="text-xs text-gray-500">{{ rx.inventory_item?.generic_name }}</p>
            </td>
            <td class="px-3 py-3 text-gray-700">
              {{ rx.dose || '—' }}
            </td>
            <td class="px-3 py-3 text-gray-700">
              {{ rx.inventory_dosage_frequency?.name || '—' }}
            </td>
            <td class="px-3 py-3 text-gray-700">
              {{ rx.administration_route?.name || '—' }}
            </td>
            <td class="px-3 py-3 text-gray-700">
              {{ rx.days ? rx.days + (rx.days === 1 ? ' day' : ' days') : '—' }}
            </td>
            <td class="px-3 py-3 text-gray-700">
              {{ rx.quantity || '—' }}
            </td>
            <td class="px-3 py-3">
              <span
                class="text-xs px-2 py-0.5 rounded-full border"
                :class="statusStyle(rx.status?.name)"
              >
                {{ rx.status?.name || 'Unknown' }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Notes per prescription -->
      <div
        v-for="(rx, index) in prescriptionsWithNotes"
        :key="'note-' + index"
        class="mt-2 px-3 text-xs italic"
      >
        <div class="flex-col space-y-2">
          <p>Prescription notes:</p>
          <span class="text-gray-600">{{ rx.notes }}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'PharmacyStageView',
  props: {
    detail: { type: Object, required: true },
  },
  computed: {
    prescriptions() {
      return this.detail.prescriptions || []
    },
    prescriptionsWithNotes() {
      return this.prescriptions.filter(rx => rx.notes)
    },
  },
  methods: {
    statusStyle(statusName) {
      const s = (statusName || '').toLowerCase()
      if (s.includes('dispens')) return 'bg-green-50 text-green-700 border-green-200'
      if (s.includes('pending') || s.includes('prescribed')) return 'bg-yellow-50 text-yellow-700 border-yellow-200'
      if (s.includes('cancel')) return 'bg-red-50 text-red-700 border-red-200'
      return 'bg-gray-50 text-gray-600 border-gray-200'
    },
  },
}
</script>
